import { useEffect, useState } from 'react'
import { api, session } from '../api.js'
import ChercherPersonne from '../components/ChercherPersonne.jsx'

// Les services de la mairie : qui répond à quoi, et qui travaille où.
export default function Services() {
  const [liste, setListe] = useState([])
  const [ouvert, setOuvert] = useState(null)
  const [ajout, setAjout] = useState(false)
  const [erreur, setErreur] = useState('')
  const [message, setMessage] = useState('')

  const charger = () => { api.services().then(setListe).catch((e) => setErreur(e.message)) }
  useEffect(() => { charger() }, [])
  const lectureSeule = session.env === 'live'

  async function supprimer(svc) {
    if (!confirm(`Supprimer le service « ${svc.name} » ?`)) return
    try { await api.deleteService(svc.key); setErreur(''); charger() }
    catch (e) { setErreur(e.message) }
  }

  return (
    <>
      <h1>Services</h1>
      <p className="chapo">Un service, c'est une équipe qui répond à un type de demandes. Un dossier
        confié à un service reste accessible à toute l'équipe, même quand quelqu'un est absent.</p>
      {erreur && <p className="erreur" role="alert">{erreur}</p>}
      {message && <p className="succes" role="status">{message}</p>}

      {!lectureSeule && (
        <button className="btn pri" onClick={() => setAjout(!ajout)}>
          {ajout ? 'Annuler' : 'Créer un service'}
        </button>
      )}

      {ajout && <Formulaire onFini={() => { setAjout(false); charger() }} onErreur={setErreur} />}

      <div className="grille">
        {liste.map((svc) => (
          <article className="fiche" key={svc.key}>
            <h3>{svc.name}</h3>
            <p>{svc.description}</p>
            <dl className="chiffres">
              <div><dt>agents</dt><dd>{svc.agents}</dd></div>
              <div><dt>dossiers en cours</dt><dd>{svc.dossiers}</dd></div>
            </dl>
            <p className="aide">
              {svc.demarches.length
                ? `Répond à : ${svc.demarches.join(', ')}`
                : "Aucune démarche ne lui est rattachée pour l'instant"}
            </p>
            {!lectureSeule && (
              <div className="ligne">
                <button className="btn sm" onClick={() => setOuvert(svc)}>Qui y travaille</button>
                <button className="btn sm dgr" onClick={() => supprimer(svc)}>Supprimer</button>
              </div>
            )}
          </article>
        ))}
        {!liste.length && (
          <div className="carte vide">
            <h2>Aucun service</h2>
            <p>Créez-en un par équipe : accueil, technique, scolaire, urbanisme.</p>
          </div>
        )}
      </div>

      {ouvert && <Equipe service={ouvert} onFermer={() => { setOuvert(null); charger() }}
                        onMessage={setMessage} />}
    </>
  )
}

function Formulaire({ onFini, onErreur }) {
  const [nom, setNom] = useState('')
  const [description, setDescription] = useState('')
  const [email, setEmail] = useState('')

  async function creer(e) {
    e.preventDefault()
    try { await api.createService({ name: nom, description, email }); onFini() }
    catch (err) { onErreur(err.message) }
  }

  return (
    <form className="carte" onSubmit={creer}>
      <h2>Nouveau service</h2>
      <div className="champ">
        <label htmlFor="s-nom">Nom</label>
        <input id="s-nom" value={nom} onChange={(e) => setNom(e.target.value)} required
               placeholder="Services techniques" />
      </div>
      <div className="champ">
        <label htmlFor="s-desc">Ce dont il s'occupe</label>
        <input id="s-desc" value={description} onChange={(e) => setDescription(e.target.value)}
               placeholder="Voirie, propreté, bâtiments, espaces verts" />
      </div>
      <div className="champ">
        <label htmlFor="s-mail">Adresse électronique du service</label>
        <input id="s-mail" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
               placeholder="technique@mairie.fr" />
        <p className="aide">Facultative. Sert à prévenir l'équipe entière plutôt qu'une personne.</p>
      </div>
      <button className="btn pri">Créer</button>
    </form>
  )
}

function Equipe({ service, onFermer, onMessage }) {
  const [agents, setAgents] = useState([])
  const [replie, setReplie] = useState(true)

  const charger = () => { api.serviceAgents(service.key).then(setAgents) }
  useEffect(() => { charger() }, [service.key])   // eslint-disable-line

  const dedans = agents.filter((a) => a.dedans)

  async function basculer(agent, dedans) {
    await api.setServiceAgent(service.key, agent.id, dedans)
    onMessage(dedans ? `${agent.name} rejoint ${service.name}.`
                     : `${agent.name} ne fait plus partie de ${service.name}.`)
    charger()
  }

  return (
    <div className="fenetre" role="dialog" aria-label={`Équipe de ${service.name}`}>
      <div className="fenetre-corps">
        <h2>Qui travaille dans {service.name}</h2>
        <p className="aide">Ces personnes voient et traitent les dossiers confiés à ce service.</p>
        <ChercherPersonne gens={agents} placeholder="Chercher une personne à rattacher…"
                          onChoisir={(a) => (a.dedans
                            ? onMessage(`${a.name} fait déjà partie de ${service.name}.`)
                            : basculer(a, true))} />

        <ul className="equipe">
          {(replie ? dedans : agents).map((a) => (
            <li key={a.id}>
              <label className="case">
                <input type="checkbox" checked={a.dedans}
                       onChange={(e) => basculer(a, e.target.checked)} />
                <span><strong>{a.name}</strong><span className="mono petit"> {a.email}</span></span>
              </label>
            </li>
          ))}
          {!dedans.length && replie && (
            <li className="aide">Personne dans ce service pour l'instant.</li>
          )}
        </ul>

        {agents.length > dedans.length && (
          <button className="lien-mini" onClick={() => setReplie(!replie)}>
            {replie
              ? `Voir les ${agents.length - dedans.length} autres personnes de la collectivité`
              : "Ne montrer que l'équipe"}
          </button>
        )}
        <div className="ligne separee">
          <div className="pousse" />
          <button className="btn pri" onClick={onFermer}>Terminé</button>
        </div>
      </div>
    </div>
  )
}

